import type { Question } from "@/types";
import DateQuestion from "./date-question";
import AgeQuestion from "./age-question";
import { validate as validateAgeQuestion } from "./age-question";
import { validate as validateDateQuestion } from "./date-question";

interface DateAgeQuestionProps {
  question: Question;
}

export const validate = async (
  value: any,
  question: Question
): Promise<any> => {
  return question.subtype == "age"
    ? validateAgeQuestion(value, question)
    : validateDateQuestion(value, question);
};

const DateAgeQuestion = ({ question }: DateAgeQuestionProps): JSX.Element => {
  return question.subtype == "age" ? (
    <AgeQuestion question={question} />
  ) : (
    <DateQuestion question={question} />
  );
};

export default DateAgeQuestion;
